"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcTable = function ArcTable(_ref) {
  var columns = _ref.columns,
    rows = _ref.rows,
    size = _ref.size,
    rowselection = _ref.rowselection,
    bordered = _ref.bordered,
    title = _ref.title,
    footer = _ref.footer,
    expandable = _ref.expandable,
    scrolly = _ref.scrolly,
    pageSize = _ref.pageSize,
    onChange = _ref.onChange,
    pagingationChange = _ref.pagingationChange;
  return /*#__PURE__*/_react["default"].createElement(_lib.Table, {
    columns: columns,
    dataSource: rows,
    size: size,
    rowSelection: rowselection && rowselection,
    bordered: bordered && bordered,
    title: title && title,
    footer: footer && footer,
    expandable: expandable,
    pagination: {
      pageSize: pageSize,
      onChange: pagingationChange
    },
    scroll: {
      y: scrolly
    },
    onChange: onchange
  });
};
var _default = ArcTable;
exports["default"] = _default;